<script setup lang="ts">
import { stripBlockTags } from '@/composables/helpers/html';
const props = defineProps({
    headline: {
        type: String,
        required: true,
    },
    copy: {
        type: String,
    },
    image: {
        type: Object,
        required: true,
    },
    hideTopDecorations: {
        type: Boolean,
        default: false,
    },
    hideBottomDecorations: {
        type: Boolean,
        default: false,
    },
    cards: {
        type: Array,
    }
});
</script>

<template>
    <section class="block-manual-entry-three-up
        bg-gradient-to-br from-[var(--orange)] via-[var(--orange)] to-[var(--purple,#820CA7)] text-white
        py-[43px] lg:pt-[3.0625rem] lg:pb-0
        text-[16px] font-light leading-[26px] tracking-[0.32px]"
        :class="{
            'has-headline': headline,
        }"
        tabindex="-1">

        <div class="max-w-[1360px] w-[calc(1360/1440*100vw)] mx-auto">

            <!-- Text Container -->
            <div v-if="headline || copy"
                class="lg:mb-[2.8125rem] lg:max-w-[80%]">
                <MessHtml tag="h2" :html="stripBlockTags(headline)"
                    class="font-hubspot-serif font-normal mb-3
                        text-[calc(42/var(--base-fs)*1rem)] leading-[1.1] tracking-normal
                        lg:text-[calc(60/var(--base-fs)*1rem)] lg:mb-4" />
                <MessHtml v-if="copy" :html="copy"
                    class="font-hubspot-sans text-white
                        text-[calc(16/var(--base-fs)*1rem)] font-light leading-[26px] tracking-[0.32px]" />
            </div>

            <!-- Cards -->
            <div class="manual-entry-cards flex flex-col gap-[2.5rem]
                lg:flex-row lg:justify-center">
                <FragmentsCardsThreeUpCard
                    v-for="(card, index) in cards"
                    :key="`${card.headline}-${index}`"
                    :headline="card.headline"
                    :copy="card.copy"
                    :image="card.image"
                    :button="card.button" />
            </div>
        </div>
    </section>
</template>

<style>
/* [state] desktop padding adjustments for headline presence */
@media (min-width: 1024px) {
    .block-manual-entry-three-up.has-headline {
        padding-top: 6.125rem;
        padding-bottom: 6.125rem;
    }
}

/* [child] targets .card element inside child component */
@media (min-width: 1024px) {
    .manual-entry-cards .card {
        width: 100%;
    }
}
</style>
